/* eslint-disable max-len */
import React, { useContext, useState } from 'react'
import BannerImage from './BannerImage'
import LoginPage from './LoginPage'
import Otp from './Otp'
import { Auth } from 'aws-amplify';
import GlobalContext from '../../components/Context/GloablContext';
import { setUserType, verifyOtp } from './authSlice';
import { useDispatch } from 'react-redux';
import { useNavigate, } from 'react-router-dom';
import BranchSelectionComponent from './branchSelection';
import { AddBranch } from '../../redux/GlobalSlice';
import ForgotPassword from './ForgotPassword';
import { CognitoCurrentData, CognitoData } from '../../CommonMethods/CognitoData';
import { FetchBranch } from '../../CommonMethods/FetchBranch';
import { dataService } from '../../services/data.services';
import { handleGroup } from '../../redux/commonSlice';

export default function Login() {
    const location = useNavigate()
    const dispactch = useDispatch()
    const { setToastmessage, setToastErrorMessage, UpdateCall, setUpdateCall, setIsInactiveBranch } = useContext(GlobalContext)
    const [IsLoginPage, setIsLoginPage] = useState(true);
    const [loading, setloading] = useState(false);
    const [userData, setuserData] = useState({});
    const [myInfo, setmyInfo] = useState({})
    const [branchSeclection, setbranchSeclection] = useState('')
    const [loginCredentials, setloginCredentials] = useState({
        email: '',
        password: ''
    });
    const [error, seterror] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [otp, setOtp] = useState(Array(6).fill(""));
    const [timer, setTimer] = useState(30);
    const [loginError, setloginError] = useState('')
    const [isForgotPassword, setIsForgotPassword] = useState(false);
    const { email, password } = loginCredentials

    /**
     * The function `handleLoginCredentials` updates the `loginCredentials` state object by setting the
     * value of a specific key.
     */
    const handleLoginCredentilas = (key, value) => {
        setloginCredentials((current) => ({
            ...current,
            [key]: value
        }))
    }

    /**
     * The above function handles the login process, including sending an OTP to the registered email
     * and handling various error scenarios.
     */
    const handleLogin = async (e, key) => {
        seterror(false)
        setEmailError(false)
        setPasswordError(false)
        e.preventDefault();
        if (key === undefined) {
            setloading(true);
            setOtp(Array(6).fill(""))

        }
        try {
            const loginresponse = await Auth.signIn(email.toLowerCase(), password);
            setuserData(loginresponse);
            setloading(false)
            setIsLoginPage(false);
            setToastmessage('OTP sent to registered email successfully!')
            if (key) {
                setTimer(30)
            }
            // Login successful, redirect or perform any other actions
        } catch (error) {
            if (error.code === 'UserNotConfirmedException') {
                // User is not confirmed
                // Show a message or redirect to a confirmation page
                setloginError('UserNotConfirmedException')
                setEmailError(true)
            } else if (error.code === 'NotAuthorizedException' && error.message !== 'User is disabled.') {
                // Incorrect password
                // Show an error message
                setloginError('Incorrect Password')
                setPasswordError(true)
            } else if (error.code === 'NotAuthorizedException' && error.message === 'User is disabled.') {
                setloginError('Your account is disabled. Please contact our support team for assistance.')
                setEmailError(true)
                setPasswordError(true)
            } else if (error.code === 'UserNotFoundException') {
                // User does not exist
                // Show an error message or redirect to a signup page
                setloginError('No account found with this email. Please verify your details or Sign Up')
                setEmailError(true)
            } else if (error.code === "InvalidLambdaResponseException") {
                setloginError('Your account is disabled. Please contact our support team for assistance.')
                setEmailError(true)
                setPasswordError(true)
                setloginError('Your account is disabled. Please contact our support team for assistance.')
                setEmailError(true)
                setPasswordError(true)
            } else if (error.code === "UserLambdaValidationException") {
                if(error.message.includes('User does not exist'))
                {   setloginError('No account found with this email. Please verify your details or Sign Up')
                    setEmailError(true)
                }
                // Handle other exceptions or display a generic error message
                else{
                    setloginError('Incorrect email address or password')
                    setEmailError(true)
                    setPasswordError(true)
                }
            } else if (error.code === "InvalidParameterException") {
                // Handle other exceptions or display a generic error message
                setloginError('Incorrect email address or password')
                setEmailError(true)
                setPasswordError(true)
            } else {
                setloginError('Something went wrong')
                setEmailError(true)
                setPasswordError(true)
            }
            setloading(false);

        }
    };

    /**
     * The handleVerify function performs several tasks related to user verification and login,
     * including fetching data, dispatching actions, setting local storage items, and updating state
     * variables.
     */
    const handleVerify = async (item, info) => {
        const data = await CognitoCurrentData();
        const branch = await FetchBranch(data);
        const logoutChannel = new BroadcastChannel('logout-channel');
        logoutChannel.postMessage({ 
            type:'login',  
            data : {
                myInfo: myInfo, 
                email: email, 
                branch: branch, 
                item: item, 
                info: info
            } 
        });
        dispactch(AddBranch(branch))
        const isInactive = (item.status!=undefined&&!item.status);
        const branchNameWithStatus = item.name +(isInactive?" (Inactive)":"");
        localStorage.setItem('branch_details', JSON.stringify({ name: item?.name, id: item?.id, status: !isInactive,branchNameWithStatus:branchNameWithStatus  }))
        localStorage.setItem('user-info', JSON.stringify(info || myInfo));
        localStorage.setItem('user', true)
        localStorage.setItem('email', email)
        dispactch(verifyOtp(email));
        setUpdateCall(!UpdateCall)
        setToastmessage('Signed in Successfully.');
        setIsInactiveBranch(isInactive)
    }

    /**
     * The function `handleOTPVerification` is an asynchronous function that handles the verification
     * of a One-Time Password (OTP) in a React application.
     * @returns The function `handleOTPVerification` does not have a return statement.
     */
    const handleOTPVerification = async (e) => {
        const FYChannel = new BroadcastChannel('fy-channel');
        e.preventDefault();
        setloading(true)
        const val = otp.toString().replace(/,/g, '')
        if (val.split('')?.length >= 6) {

            try {
                const data = await Auth.sendCustomChallengeAnswer(
                    userData,
                    val,
                );
                if (data.Session == null) {
                    if (data.attributes['custom:is_first_time_login'] === "true") {
                        localStorage.setItem('custom:is_first_time_login', true);
                        localStorage.setItem('email', email);
                        setToastmessage('Signed in Successfully.')
                        location('/reset-password')

                    } else {
                        // const currentSession = await getUserRoles()
                        localStorage.setItem('custom:is_first_time_login', false);
                        const myInfo = {
                            first_name: data.attributes.name,
                            middle_name: data.attributes.middle_name,
                            role: data.attributes['custom:user_type']
                        }

                        if (data.attributes['custom:user_type'] === 'institution-user' || data.attributes['custom:user_type'] === 'institution-admin') {
                            let res;
                            let list;
                            if (data.attributes['custom:user_type'] === 'institution-admin') {
                                res = await dataService.GetAPI(`branch?&institution_id=${data.attributes['custom:institution_id']}`, true);
                                list = res.data.data.data
                            }
                            if ((data.attributes['custom:user_type'] === 'institution-admin') && list?.length === 0) {
                                setmyInfo({
                                    first_name: data.attributes.name,
                                    middle_name: data.attributes.middle_name,
                                    role: data.attributes['custom:user_type']
                                })
                                dispactch(setUserType('no-branch'));
                                dispactch(verifyOtp(email));
                                const info = { ...myInfo };
                                info.role = 'no-branch'
                                localStorage.setItem('user', true)
                                FYChannel.postMessage({ type: 'fy_fail'})
                                localStorage.setItem('user-info', JSON.stringify(myInfo));

                                location('/manage-branches/onboard-new-branch')
                                return;

                            } else {
                                localStorage.setItem('email', email)
                                setbranchSeclection(data.attributes['custom:institution_id']);
                                dispactch(setUserType(data.attributes['custom:user_type']));

                                setmyInfo({
                                    first_name: data.attributes.name,
                                    middle_name: data.attributes.middle_name,
                                    role: data.attributes['custom:user_type']
                                })
                                return;
                            }

                        } else {

                            const newdata = await CognitoData();
                            dispactch(handleGroup(newdata.idToken.payload['cognito:groups'] || []))
                            dispactch(setUserType(data.attributes['custom:user_type']))
                            handleVerify(email, myInfo)
                        }


                    }
                    setloading(false)

                } else {
                    seterror(true);
                    setloading(false)
                }

                // OTP verification successful, redirect or perform any other actions
            } catch (error) {
                seterror(true);
                setloading(false)

            }
        } else {
            seterror(true);
            setloading(false)
            return

        }
    };

    /**
     * The function `handelClear` clears the login credentials and error messages.
     */
    const handelClear = () => {
        setloginCredentials({
            email: '',
            password: ''
        });
        setloginError('')
        seterror(false)
        setEmailError(false)
        setPasswordError(false)
    }
    return (
        <div className="flex h-screen">
            <BannerImage />
            <div className="w-1/2">
                {!isForgotPassword && branchSeclection === '' && IsLoginPage && <LoginPage
                    setIsLoginPage={setIsLoginPage}
                    email={email}
                    handleLoginCredentilas={handleLoginCredentilas}
                    error={error}
                    loginError={loginError}
                    emailError={emailError}
                    passwordError={passwordError}
                    setEmailError={setEmailError}
                    setPasswordError={setPasswordError}
                    password={password}
                    loading={loading}
                    setToastErrorMessage={setToastErrorMessage}
                    setIsForgotPassword={setIsForgotPassword}
                    handleLogin={handleLogin} />}
                {!isForgotPassword && branchSeclection === '' && !IsLoginPage && <Otp
                    handleLogin={handleLogin}
                    setIsLoginPage={setIsLoginPage}
                    setOtp={setOtp}
                    handleOTPVerification={handleOTPVerification}
                    otp={otp}
                    setTimer={setTimer}
                    timer={timer}
                    error={error}
                    loading={loading}
                    seterror={seterror}
                    handelClear={handelClear}
                    setloading={setloading} />}
                {isForgotPassword && branchSeclection === '' && IsLoginPage &&
                    <ForgotPassword
                        setIsForgotPassword={setIsForgotPassword}
                        handelClear={handelClear}
                        emailFromLogin={email}
                    />}
                {branchSeclection && (
                    <BranchSelectionComponent
                        id={branchSeclection}
                        handleVerify={handleVerify}
                        email={email}
                        myInfo={myInfo} />
                )}
            </div>
        </div>
    )
}
